import * as React from 'react';
import { SVGProps } from 'react';

const SvgSurfSphere = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='-20 -20 80 80'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M 20.001 1 C 9.525 1 1 9.525 1 20.001 C 1 30.475 9.522 39 20.001 39 C 30.475 39 39 30.478 39 20.001 C 39 9.525 30.478 1 20.001 1 Z  M 20.001 3.975 C 26.98 3.975 32.869 8.487 35.062 14.728 C 31.364 12.651 25.582 11.557 20.001 11.557 C 14.418 11.557 8.639 12.651 4.938 14.728 C 7.134 8.49 13.023 3.975 20.001 3.975 Z  M 36.025 20.001 C 36.025 22.286 29.931 25.472 20.001 25.472 C 10.072 25.472 3.975 22.286 3.975 20.001 C 3.975 17.717 10.072 14.531 20.001 14.531 C 29.931 14.531 36.025 17.717 36.025 20.001 Z  M 20.001 36.025 C 13.023 36.025 7.134 31.513 4.938 25.275 C 8.639 27.352 14.418 28.446 20.001 28.446 C 25.582 28.446 31.364 27.352 35.062 25.275 C 32.869 31.513 26.983 36.025 20.001 36.025 Z'
      fill='#000'
    />
  </svg>
);

export default SvgSurfSphere;
